<div class="menu-container">

  <div class="row-welcome">
    <div class="row-welcome-icon">
      <mat-icon>account_circle</mat-icon>
    </div>
    <div>
      Bienvenido(a),
      <br>
      {{userInfo.name}}
    </div>

  </div>

  <div class="row-data">
    <span class="menu-label">Oficina:</span>
    <br>
    {{userInfo.office}}
  </div>

  <div class="row-data">
    <span class="menu-label">Último acceso:</span>
    <br>
    {{userInfo.lastAccess}}
  </div>
</div>

<ng-container *ngFor="let link of menu">

  <ng-container *ngIf="link.children;else simpleLink">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-icon
            *ngIf="link.icon"
            class="menu-icon">
            {{link.icon}}
          </mat-icon>
          {{link.label}}
        </mat-expansion-panel-header>
        <mat-nav-list>
          <a
            mat-list-item
            *ngFor="let item of link.children"
            class="menu-list-item"
            [routerLink]="['/'+item.route]"
            [routerLinkActiveOptions]="{exact:true}"
            routerLinkActive="router-link-active">
            {{ item.label }}
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>

  <ng-template #simpleLink>
    <mat-nav-list>
      <a
        mat-list-item
        class="menu-list-item"
        [routerLink]="['/'+link.route]"
        [routerLinkActiveOptions]="{exact:true}"
        routerLinkActive="router-link-active">
        <mat-icon
          *ngIf="link.icon"
          class="menu-icon">
          {{link.icon}}
        </mat-icon>
        {{ link.label }}
      </a>
    </mat-nav-list>
  </ng-template>

</ng-container>
